/*
 * Authors: mariushirjanu
 * Created: 18/07/2024
 */
import * as _ from 'underscore';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DefaultFormDialogComponent } from '../../../../shared/message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { Override } from '../../../../shared/app-decorators';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { BPProfilesAccreditationsDataService, IBPProfileAccreditation } from './bp-profiles-accreditations-data.service';
import { BPProfilesService } from '../../bp-profiles.service';

export interface IEditAccreditationModel extends IBPProfileAccreditation {
  accreditationName:string;
  active:boolean;
  comment:string;
}

@Component({
  selector: 'edit-accreditation-dialog',
  templateUrl: '../../../../shared/message/dialogs/default-form-dialog.html'
})
export class EditAccreditationDialogComponent extends DefaultFormDialogComponent {
  @Input() public accreditationId:number;
  @Input() public accreditationName:string;
  @Output() public onSaved:EventEmitter<IBPProfileAccreditation> = new EventEmitter<IBPProfileAccreditation>();
  @Output() public onSaving:EventEmitter<boolean> = new EventEmitter<boolean>();

  public model:IEditAccreditationModel;

  constructor(
    private formlyService:GaFormlyService,
    private bpProfilesService:BPProfilesService,
    private bpProfilesAccreditationsDataService:BPProfilesAccreditationsDataService,
    protected translationService:TranslationService,
    protected validateService:GaValidateService
  ) {
    super(validateService, translationService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit():void {
    super.ngOnInit();
    this.fields = this.createFields();
    this.model.accreditationName = this.accreditationName; // accreditationName is set from the report
  }

  @Override(DefaultFormDialogComponent)
  public getModel():IBPProfileAccreditation {
    return _.omit(this.model, 'accreditationName');
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';

    return [
      this.formlyService.aValue('accreditationName', 'BPPROFILES.ACCREDITATIONS.ACCREDITATION.LABEL')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),

      // show covered field only for existing accreditation
      this.formlyService.aCheckbox('active', 'BPPROFILES.ACCREDITATIONS.ACTIVE.LABEL')
        .withoutWrapper()
        .withWrapperClass('col-space-minus-top')
        .build(),

      // show the comment only for existing accreditation
      this.formlyService.aTextarea('comment', 'GA.GENERAL.COMMENTS')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build()
    ];
  }

  public save = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.onSaving.emit(true);
        this.saveButtonBusy = true;
        this.bpProfilesAccreditationsDataService.updateAccreditation(this.bpProfilesService.activeProfile?.id, this.accreditationId, this.getModel())
          .then(() => {
            // just notify browselist that the save took place (uses reload ALL rows)
            this.onSaved.emit();
          })
          .finally(() => {
            this.onSaving.emit(false);
            this.saveButtonBusy = false;
          });
      });
  };
}